import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
} from '@mui/material'

const CreateListDialog = ({ open, onClose, onCreate }) => {
  const [listName, setListName] = useState('')

  const handleCreate = () => {
    const name = listName.trim() || `Liste de course du ${new Date().toLocaleDateString()}`
    onCreate({ name })
    setListName('')
  }

  const handleClose = () => {
    setListName('')
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Créer une Nouvelle Liste de Courses</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="Nom de la Liste (Optionnel)"
            value={listName}
            onChange={(e) => setListName(e.target.value)}
            placeholder={`Liste de course du ${new Date().toLocaleDateString()}`}
            helperText="Laissez vide pour générer automatiquement un nom avec la date d'aujourd'hui"
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleCreate()
              }
            }}
          />
          
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Vos articles par défaut et articles récurrents (si dus) seront automatiquement ajoutés à la nouvelle liste.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Annuler</Button>
        <Button onClick={handleCreate} variant="contained">
          Créer la Liste
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CreateListDialog
